<div class="card-body p-2">
  <div class="sport">
    <img src="./assets/images/{{ video.sport }}.svg" [alt]="video.sport" height="22" />
  </div>
  <div class="slope-status">
    <i class="fas fa-user-edit" *ngIf="video.approved === 0" [ngbTooltip]="'EDITION.EDITION.undefined' | translate"
      placement="bottom-right"></i>
    <i class="fas fa-check" *ngIf="video.approved === 1" [ngbTooltip]="'EDITION.EDITION.approuved' | translate"
      placement="bottom-right"></i>
    <i class="fas fa-times" *ngIf="video.approved === 2" [ngbTooltip]="'EDITION.EDITION.refused' | translate"
      placement="bottom-right"></i>
    <i class="fas fa-user-check" *ngIf="video.approved === 3"
      [ngbTooltip]="'EDITION.EDITION.slopeProcessed' | translate" placement="bottom-right"></i>
  </div>
  <div class="video-thumbnails">
    <img class="video-img" [src]="video.thumbnails?.medium" />
    <div class="view-count">
      <i class="fas fa-eye"></i>
      {{ video.views_count }}
    </div>
    <div [ngbTooltip]="
        ('EDITION.SLOPE-EDITOR.options.promote' | translate) +
        ': ' +
        ('EDITION.SLOPE-EDITOR.promote.status.' + video.submission_status
          | translate
          | lowercase)
      " placement="top-left" class="promote-status" *ngIf="
        video.submission_status !== null &&
        video.submission_status !== undefined
      ">
      <i class="icon fas fa-times-circle" *ngIf="+video.submission_status === 0"></i>
      <i class="icon fas fa-spinner" *ngIf="+video.submission_status === 1"></i>
      <i class="icon fas fa-check" *ngIf="+video.submission_status === 2"></i>
      <i class="icon fas fa-play" *ngIf="+video.submission_status === 3"></i>
    </div>
  </div>
  <div class="title">
    <span>{{ video.name }}</span>
  </div>
  <div class="stats">
    <div class="stat">
      <span class="value">{{ video.distance | formatVideoStats : 'kms' }}</span>
      <span class="unity">kms</span>
      <i class="fas fa-arrows-alt-h"></i>
    </div>
    <div class="stat">
      <span class="value">{{
        video.duration | formatVideoStats : 'mins'
        }}</span>
      <span class="unity">mins</span>
      <i class="fas fa-clock"></i>
    </div>
    <div class="stat">
      <span class="value">{{ video.positive_slope }}</span>
      <span class="unity">m</span>
      <i class="fas fa-mountain"></i>
    </div>
    <div class="stat">
      <span class="value">{{ video.avg_speed }}</span>
      <span class="unity">km/h</span>
      <i class="fas fa-tachometer-alt"></i>
    </div>
  </div>
  <div class="author" *ngIf="video.author">
    <img [src]="video.author?.avatar_url" height="28" [alt]="video.author?.username" />
    <span>{{ video.author?.username }}</span>
    <div class="country-flag" *ngIf="video.country_start">
      <img src="./assets/images/newFlags/{{ video.country_start.code }}.png" [alt]="video.country_start.name"
        height="25" />
    </div>
  </div>
</div>